import { createFileRoute } from "@tanstack/react-router";
import { BridgeGuidePage } from "../features/printers/bridge-guide";

/** More > Printers > Print Bridge: download, install, detect (P5-T29). */
export const Route = createFileRoute("/more/printers/bridge")({ component: BridgeGuidePage });
